import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// import Route from 'route-parser';

// Local Deps
import { requestUserById, updateUser } from './graphql';
// import {
//   editUserRoute,
// } from '../../config/navigation/routes';
import { getOrgAdmins } from '../../../graphql/organizationDetails';
import setUpdated from '../../Associations/setUpdated';
// import { emailIsValidAndUnsassigned2 } from '../../../utils/asyncValidations';

export default function EditUserHOC(EditUserPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
        role: PropTypes.string,
      }).isRequired,
      // history: PropTypes.any.isRequired,
      selectedUserId: PropTypes.string.isRequired,
      showEditModal: PropTypes.bool.isRequired,
      closeEditModal: PropTypes.func.isRequired,
      refreshUsers: PropTypes.func.isRequired,
    };

    static initialState = {
      isLoading: true,
      initialValues: {
        id: '',
        fullName: '',
        email: '',
        phoneNumber: '',
        faxNumber: '',
        iconStatus: '',
        role: 'user',
      },
      // showConfirmation: false,
      alertMessage: '',
      values: {},
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      // const {
      //   location: { pathname },
      // } = this.props;
      // const route = new Route(editUserRoute);
      // const { userId } = route.match(pathname);
      const response = await requestUserById(this.props.selectedUserId);
      let role;
      if (response.user.role !== null) {
        if (response.user.role === 'super_admin') {
          role = 'super';
        } else if (response.user.role.includes('admin')) {
          role = 'admin';
        } else {
          role = 'user';
        }
      } else {
        role = 'user';
      }
      this.setState({
        // userId: this.props.selectedUserId,
        values: {
          ...response.user,
          role,
          id: this.props.selectedUserId,
        },
        isLoading: false,
      });
    }

    _onChangeRole = (role) => {
      if (role === "admin" || role === "super") {
        this.setState(prevState => ({
          values: {
            ...prevState.values,
            permissions: [1, 2, 3],
            role
          }
        }))
      }
      else {
        this.setState(prevState => ({
          values: {
            ...prevState.values,
            role
          }
        }))
      }
    }

    _onChangeField = (value, fieldname) => {
      this.setState(prevState => ({
        values: {
          ...prevState.values,
          [fieldname]: value
        }
      }))
    }

    _onSubmit = async event => {
      const {
        name,
        // email,
        phoneNumber,
        faxNumber,
        iconStatus,
        permissions,
      } = event;
      let { role } = event;
      const userId = this.props.selectedUserId;
      const { organizationId } = this.state.values;

      if (!role) {
        role = 'user';

      } else if (this.props.auth.role !== 'SUPER_ADMIN' && role === 'super') {
        role = 'admin'

      } else if (this.props.auth.role !== 'SUPER_ADMIN' && this.props.auth.role !== 'COMMON_ADMIN') {
        role = 'user'
      }
      // const emailInUse = await emailIsValidAndUnsassigned2(email, userId)
      // if (emailInUse) {
      //   this.setState({
      //     alertType: 'warning',
      //     alertMessage: emailInUse,
      //   });
      //   console.log("emailIsValidAndUnsassigned", emailInUse)
      //   return
      // }
      const {
        organization: { admins },
      } = await getOrgAdmins(organizationId);
      if (admins.length === 1 && admins[0].id === userId) {
        try {
          await setUpdated(organizationId);
          await updateUser({
            id: userId,
            organizationId,
            name,
            // email,
            phoneNumber,
            faxNumber,
            iconStatus,
            role: 'admin',
            permissions,
            //  convoTypeList: permissions,
          });
          this.setState({
            alertType: 'success',
            alertMessage: `The user has been successfully updated! Please note the following: \n According to our records ${name} is your organizations last Administrator. Each Organization requires at least 1 Administrator. As a result, their role as ${role}, and only their role has not been updated. If you believe there is an error or if you have any other questions, please contact support. `,
          });

          setTimeout(() => { this.props.closeEditModal(); this.props.refreshUsers() }, 2000);
        } catch (error) {
          this.setState({
            alertType: 'warning',
            alertMessage:
              'There was an error during submission, please try again in a few minutes',
          });
        }
      } else {
        try {
          await setUpdated(organizationId);
          await updateUser({
            id: userId,
            organizationId,
            name,
            // email,
            phoneNumber,
            faxNumber,
            iconStatus,
            role,
            permissions,
            //   convoTypeList: permissions,
          });
          this.setState({
            alertType: 'success',
            alertMessage: 'User updated!',
          });
          // const history = useHistory()
          // setTimeout(() => this.props.history.goBack(), 2000);
          setTimeout(() => { this.props.closeEditModal(); this.props.refreshUsers() }, 2000);
        } catch (error) {
          console.error(error);
          this.setState({
            alertType: 'warning',
            alertMessage:
              'There was an error during submission, please try again in a few minutes',
          });
        }
      }
    };

    render() {
      const { values, isLoading, alertType, alertMessage } = this.state;
      const { auth, showEditModal, closeEditModal } = this.props;
      const pageProps = {
        auth,
        initialValues: values,
        onSubmit: this._onSubmit,
        isLoading,
        alertType,
        alertMessage,
        onChangeRole: this._onChangeRole,
        onChangeField: this._onChangeField,
        showEditModal,
        closeEditModal
      };
      return <EditUserPage {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/Modals/EditUser/EditUserHOC.jsx